import { isCurrentMediaTypeImage } from 'redux/currentMedia/selectors'
import {
    getCurrentImageRect,
    getProjection,
    getScaledCurrentImageRect,
    mainViewId,
} from '../canvas/selectors'
import {
    getFilters,
    getRotation,
    isInvertActive
} from '../appliedFilters/selectors'
import { PRINT_EVENT } from '../../helpers/print'
import {
    getPrintOrientation,
    getPrintMediaTitle,
    isPrintPreviewOpened,
} from './selectors'
import {
    closeAllLeftAsides,
    lockLeftAside,
    unlockLeftAside,
} from '../aside/actions'
import { getCurrentMediaProps } from "../mediaList/selectors"

export function togglePrintPreview() {
    return function togglePrintPreview(dispatch, getState) {
        if(! isCurrentMediaTypeImage(getState()))
        {
            return
        }

        if(isPrintPreviewOpened(getState()))
        {
            dispatch(closePrintPreview())

            return
        }

        dispatch(openPrintPreview())
    }
}

export const OPEN_PRINT_PREVIEW = 'OPEN_PRINT_PREVIEW'
export function openPrintPreview()
{
    return function openPrintPreview(dispatch)
    {
        dispatch(closeAllLeftAsides())
        dispatch(lockLeftAside('print'))
        dispatch({ type: OPEN_PRINT_PREVIEW })
    }
}

export const CLOSE_PRINT_PREVIEW = 'CLOSE_PRINT_PREVIEW'
export function closePrintPreview()
{
    return function closePrintPreview(dispatch)
    {
        dispatch(unlockLeftAside())
        dispatch({ type: CLOSE_PRINT_PREVIEW })
    }
}

export const PORTRAIT_ORIENTATION = 'PORTRAIT_ORIENTATION'
export const portraitOrientation = () => ({ type: PORTRAIT_ORIENTATION })

export const LANDSCAPE_ORIENTATION = 'LANDSCAPE_ORIENTATION'
export const landscapeOrientation = () => ({ type: LANDSCAPE_ORIENTATION })

export const determinePrintOrientation = () => (dispatch, getState) => {
    const state = getState()
    const rotation = getRotation(state)
    const imageRect = getScaledCurrentImageRect(state, mainViewId).rotate(rotation)
    const { frame } = getProjection(state, mainViewId)

    if(Math.min(imageRect.width, frame.width) / Math.min(imageRect.height, frame.height) > 1)
    {
        dispatch(landscapeOrientation())

        return
    }

    dispatch(portraitOrientation())
}

export const print = () => (dispatch, getState) => {
    const state = getState()
    const event = new CustomEvent(PRINT_EVENT, {
        'detail': {
            title: getPrintMediaTitle(state),
            orientation: getPrintOrientation(state),
            ...getCurrentImageRect(state),
            location: getCurrentMediaProps(state).location.original,
            isInvertActive: isInvertActive(state),
            filters: getFilters(state),
        },
    })

    document.dispatchEvent(event)
}
